import type { TRule } from 'fela';

export const footer: TRule = () => ({
    textAlign: 'center',
});
